class Collapse {
    constructor() {
        this.collapsePages = document.querySelector(".page-template-template-home, .page-template-template-perso, .page-template-default");
        if (!this.collapsePages) {
            return;
        }
        this.buildCollapse();
    }

    buildCollapse(){
        document.querySelectorAll('.collapse').forEach(collapse => {
            const collapseHead = collapse.querySelector(".collapse-head");
            const collapseIcon = collapseHead.querySelectorAll('.icon');
            collapseHead.addEventListener("click", () => {
                collapse.classList.toggle("show");
                collapseIcon.forEach(item => {
                    item.classList.toggle("rotate");
                });
            });
        });
    }
}